package it.neckar.lizergy.model.http

import it.neckar.open.http.UrlPattern

interface Endpoints {
  val baseUrl: UrlPattern.Relative0

  val heartbeatUrl: UrlPattern.Relative0
    get() = baseUrl + "heartbeat"
}
